import { Card, CardContent, CardHeader, useTheme } from "@mui/material";
import { blue, deepPurple, orange } from "@mui/material/colors";
import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import { notiError } from "../../utils/notiUltils";
import dayjs from "dayjs";

function Performance({ id, api, alarmReal }) {
  const [labels, setLabels] = useState([]);
  const [series, setSeries] = useState([
    {
      name: "เขตชุมชน",
      data: [0, 0, 0, 0, 0, 0],
    },
    {
      name: "พื้นที่เสี่ยง",
      data: [0, 0, 0, 0, 0, 0],
    },
    {
      name: "จำกัดความเร็ว",
      data: [0, 0, 0, 0, 0, 0],
    },
  ]);
  const [dataSource, setDataSource] = useState(null);
  const theme = useTheme();
  useEffect(() => {
    const options = {
      chart: {
        type: "radar",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
        height: 300,
      },
      series: series,
      labels: labels,
      fill: {
        opacity: 0.5,
        colors: [orange[300], blue["400"], deepPurple["A200"]],
      },
      markers: {
        size: 4,
      },
      legend: {
        show: true,
        labels: {
          colors: theme.palette.mode === "dark" ? "#FFFFFF" : "#333333",
        },
        markers: {
          size: 5,
          offsetX: -5,
        },
        itemMargin: {
          horizontal: 10,
        },
      },
      yaxis: {
        show: false,
      },
    };

    const chart = new ApexCharts(document.querySelector(`#${id}`), options);

    chart.render();

    return () => {
      chart.destroy();
    };
  }, [id, labels, theme, series]);

  useEffect(() => {
    if (!dataSource) {
      return;
    }
    const categoryID0 = {
      name: "เขตชุมชน",
      data: [0, 0, 0, 0, 0, 0],
    };
    const categoryID1 = {
      name: "พื้นที่เสี่ยง",
      data: [0, 0, 0, 0, 0, 0],
    };
    const categoryID2 = {
      name: "จำกัดความเร็ว",
      data: [0, 0, 0, 0, 0, 0],
    };
    for (let i in dataSource) {
      const arr = dataSource[i];
      if (arr.length === 0) {
        categoryID0.data[i] = 0;
        categoryID1.data[i] = 0;
        categoryID2.data[i] = 0;
      } else {
        categoryID0.data[i] =
          arr.find((a) => a.CategoryID === 0)?.record_count ?? 0;
        categoryID1.data[i] =
          arr.find((a) => a.CategoryID === 1)?.record_count ?? 0;
        categoryID2.data[i] =
          arr.find((a) => a.CategoryID === 2)?.record_count ?? 0;
      }
    }
    const dataSeries = [categoryID0, categoryID1, categoryID2];
    setSeries(dataSeries);
  }, [dataSource]);

  useEffect(() => {
    if (!api) {
      return;
    }
    const now = dayjs();
    const arrayLabels = [];
    for (let i = 0; i < 6; i++) {
      arrayLabels.push(now.subtract(i, "month").format("MMM"));
      setLabels(arrayLabels);
    }

    api
      .get("/dashboard9", localStorage.getItem("token"))
      .then((data) => {
        setDataSource(data);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });
  }, [api]);

  useEffect(() => {
    if (!alarmReal) {
      return;
    }

    setDataSource((previusData) => {
      const data = [...previusData];
      const current = data[0].find(
        (a) => a.CategoryID === alarmReal.CategoryID
      );
      if (current) {
        current.record_count++;
      }
      return data;
    });
  }, [alarmReal]);

  return (
    <Card
      sx={{
        height: "100%",
        p: 1,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardHeader
        title={"ประเมินผลการแจ้งเตือน"}
        titleTypographyProps={{ variant: "subtitle1" }}
        sx={{ pb: 0 }}
      />
      <CardContent sx={{ py: 0 }}>
        <div id={id}></div>
      </CardContent>
    </Card>
  );
}

export default Performance;
